import { TransitionService, Transition } from '@uirouter/angular';

export class Analytics {
    static initialise(transitionService:TransitionService) {
        if (window.ga) {
            window.ga('create', atob('VUEtNjU2MjU4NjgtMQ=='), 'auto');
            
            var hashParts = window.location.hash.split('=');
            if (hashParts.length > 0) {
                if (hashParts[0] === '#from') {
                    window.ga('set', 'campaignSource', hashParts[1]);
                }
                window.location.hash = '';
            }
        }

        if (window.fbq) {
            window.fbq('init', '1680550805553732');
            window.fbq('track', "PageView");
        }


        transitionService.onSuccess({}, (transition:Transition) => {
            if (window.ga) {
                // https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications
                //     "...do not update the location field when tracking virtual pageviews in a single page application. Use the page field instead."
                
                // Google Analytics debugger will still pick up the old location, but the pathname will override it.
                //     "Note: If you send a hit that includes both the location and page fields and the path values are different, Google Analytics will use the value specified for the page field. "
                
                window.ga('set', 'page', window.location.pathname);            
                window.ga('send', 'pageview');
            }
            if (window.fbq) window.fbq('track', "PageView");
        });

        if (window.google_trackConversion) {
            window.google_trackConversion = window.google_trackConversion;
        }


    }

    static affiliateClick() {
        if (window.fbq) window.fbq('track', 'InitiateCheckout');
        
        if (window.ga) window.ga('send', {
            eventAction: 'buy',
            hitType: 'event',
            eventCategory: 'book'
        });

        if (window.google_trackConversion) window.google_trackConversion({
            google_conversion_id: 936021001, 
            google_conversion_label: 'MhxrCKmRomMQiZiqvgM',
            google_conversion_language: "en",
            google_conversion_format: "3",
            google_remarketing_only: false
        });
    }
    
    static search() {
        if (window.ga) window.ga('send', {
            eventAction: 'search',
            hitType: 'event',
            eventCategory: 'search'
        });
        
        if (window.fbq) window.fbq('track', 'Search');
    }

    static lookup() {
        if (window.ga) window.ga('send', {
            eventAction: 'search',
            hitType: 'event',
            eventCategory: 'lookup'
        });
        
        if (window.fbq) window.fbq('track', 'Lookup');
    }

    static addBook() {
        if (window.ga) window.ga('send', {
            eventAction: 'addBook',
            hitType: 'event',
            eventCategory: 'shelf'
        });
    }

    static createShelf() {
        if (window.ga) window.ga('send', {
            eventAction: 'create',
            hitType: 'event',
            eventCategory: 'shelf'
        });
    }

    static register() {
        if (window.ga) window.ga('send', {
            eventAction: 'register',
            hitType: 'event',
            eventCategory: 'user'
        });
        
        if (window.fbq) window.fbq('track', 'CompleteRegistration');
            
        if (window.google_trackConversion) window.google_trackConversion({
            google_conversion_id: 936021001, 
            google_conversion_label: '1lUSCNnJsmMQiZiqvgM',
            google_conversion_language: "en",
            google_conversion_format: "3",
            google_remarketing_only: false
        });
    }

    static servedByCloudflareAlwaysOnline() {
        if (window.ga) window.ga('send', {
            eventAction: 'servedByCloudflareAlwaysOnline',
            hitType: 'event',
            eventCategory: 'webPage'
        });
    }

    static importer(category:'process' | 'import' | 'findBook' | 'foundbook' | 'loadData') {
        if (window.ga) window.ga('send', {
            eventAction: 'importer',
            hitType: 'event',
            eventCategory: category
        });
    }

}


// WEBPACK FOOTER //
// ./web/static/services/Analytics.ts